import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { SelectOption } from "../../../../types/select";
import { useBookingSelector } from "./useBookingSelector";

const torRulesOptions: SelectOption[] = [
  {
    label: "Base Rent Only",
    value: "baseRentOnly",
  },
  {
    label: "Turnover Rent Only",
    value: "turnoverRentOnly",
  },
  {
    label: "Base Rent + Turnover Rent",
    value: "baseRentAndTurnoverRent",
  },
  {
    label: "Base Rent or Turnover (Higher of)",
    value: "baseRentOrTurnoverRent",
  },
];

const turnoverAllowedTorValues = new Set<string>(
  torRulesOptions.filter((option) => option.value !== "baseRentOnly").map((option) => option.value),
);

export const useTorRules = () => {
  const { torType: savedTorType } = useBookingSelector();
  const bookingFormTorType = useSelector<RootState, string | undefined>(
    (state) => state?.newBooking?.bookingForm?.torType,
  );

  const torType = useMemo(() => {
    return bookingFormTorType ?? savedTorType ?? undefined;
  }, [bookingFormTorType, savedTorType]);

  const hasValidTorType = torType != null && turnoverAllowedTorValues.has(torType);

  const isBaseRentOnly = torType === "baseRentOnly";
  const isTurnoverRentOnly = torType === "turnoverRentOnly";

  return {
    torType,
    torRulesOptions,
    hasValidTorType,
    isBaseRentOnly,
    isTurnoverRentOnly,
  };
};
